/**
 * Every financial metric is stored twice: under its bare key in the account's
 * own currency, and under the same key suffixed `Local` in the currency the
 * record was signed in. The two are shown as adjacent columns rather than one
 * column with the second figure in parentheses, so each column holds a single
 * currency and can be read, sorted and exported on its own terms.
 *
 * The naming lives here rather than beside the column definitions because the
 * column-management filter needs it too, and that module is reachable from the
 * column definitions' own import graph — spelling the suffix a second time is
 * how the terms half of each metric came to be missed.
 */
export const TERMS_FIELD_SUFFIX = "Local";

export const termsFieldName = (systemFieldName: string): string =>
  `${systemFieldName}${TERMS_FIELD_SUFFIX}`;
